import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { useIntl } from 'react-intl';
import { DatedEvidence, Evidence } from '@eas/common-web';
import { Fields } from './paragraph-fields';
import { TableToolbarImportButton } from './import-dialog/table-toolbar-import-button';
import { Paragraph } from '@models';
import { useColumns } from './paragraph-columns';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';

export function Paragraphs() {
  const intl = useIntl();

  //const validationSchema = useValidationSchema();

  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [Permission.Default.ADMINISTRATOR],
      REMOVE: [],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [Permission.Default.ADMINISTRATOR],
      SAVE: [Permission.Default.ADMINISTRATOR],
      CLOSE: [Permission.Default.ADMINISTRATOR],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<Paragraph>({
    version: 1,
    identifier: 'PARAHRAPH',
    apiProps: {
      url: EvidenceApiUrl.PARAGRAPH,
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'TAPIS__PARAHRAPH__TABLE__TITLE',
        defaultMessage: 'Správa textací',
      }),

      toolbarProps: {
        after: <TableToolbarImportButton />,
      },
      reportTag: ExportTag.PARAGRAPH_GRID,
    },
    detailProps: {
      FieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__PARAHRAPH__DETAIL__TITLE',
          defaultMessage: 'Správa textací',
        }),
        showBtn: permissions,
      },
    },
  });

  return <Evidence {...evidence} />;
}
